import Vue from 'vue'
import Vuex from 'vuex'
import API from '../base/api'
import common from '../base/commom'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    api: API,
    pval: '',
    access_token: '',
    channel: '',
    common: common,
    paymentType: 'online',
    invoiceCode: 'Person',
    invoiceTitle1: '',
    invoiceTitle2: '',
    companyTaxCode: '',
    isShowLoading: 0
  },
  getters: {
    isShowLoading(state) {
      return state.isShowLoading
    }
  },
  mutations: {
    setState(state,payload) {
      if(payload && typeof payload ==='object') {
        Object.keys(payload).forEach(val=>{
          //console.log(payload[val])
          state[val] = payload[val];
        })
      }
    },
    setPayType(state, payload) {
      state.paymentType = payload;
    },
  },
  actions: {

  },
  modules: {

  }
})
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js